import React from 'react';
import PropTypes from 'prop-types';

// Components
import Checkbox from '../core/checkbox';
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import LanguageSelect from '../app/language-select';
import rsqlConfig from '../../../config/rsql-config';
import Select from '../core/select';
import ServicesSearchForm from '../app/services-search-form';
import GenreSelect from '../app/genre-select';

function MoviesAndProgramsSearchForm(props) {
    const {noScroll, servicesDataKey} = props;

    return (
        <ServicesSearchForm formName={servicesDataKey} noScroll={noScroll} servicesDataKey={servicesDataKey}>
            <Input label="Title/Series Title" name="title||seriesTitle" />
            <Checkbox label="Exact Match" name="exactSearch" value="true" />
            <Input label="Echostar ID" name="echostarId" validate={['number']} />
            <Input label="Echostar3 ID" name="echostarEventString" />
            <Input label="AMS ID" name="roviProgramId" />
            <Input label="Tms ID" name="tmsId" />
            <Input label="Source Id" name="sourceId" />
            <Select label="Ingest Source" name="ingestSource">
                <option value="">Filter by Ingest Source</option>
                <option value="gn">GN</option>
                <option value="tivo">TIVO</option>
                <option value="dish ">DISH</option>
            </Select>
            <Input label="Series ID" name="seriesId" />
            <Input label="EIDR" name="eidrId" />
            <GenreSelect className="display-inline-block" name="genres:2" />
            <Input label="Release Year" name="releaseYear" size={12} />
            <LanguageSelect defaultOption="Filter by Title Language" label="Title Language" name="titleLanguages" />
            <LanguageSelect
                defaultOption="Filter by Description Language"
                label="Description Language"
                name="descriptionLanguage"
            />
            {servicesDataKey === 'moviesAndProgramsForNetworkDisplayPath' ? (
                <Select label="Type" name="typeFilter">
                    <option value="">Filter by Type</option>
                    <option value="movies_only">Movies</option>
                    <option value="shows_only">Shows</option>
                    <option value="sports_only">Special</option>
                </Select>
            ) : (
                <Select label="Type" name="typeFilter">
                    <option value="">Filter by Type</option>
                    <option value="movies_only">Movies</option>
                    <option value="episodes_only">Episodes</option>
                    <option value="shows_only">Shows</option>
                    <option value="sports_only">Special</option>
                </Select>
            )}
            <Select label="Adult Content" name="genres">
                <option value="">Show all content</option>
                <option value="!Adult">No adult content</option>
                <option value="Adult">Only adult content</option>
            </Select>
            <Select label="Shells" name="roviProgramId#shells">
                <option value="">Filter by Shells</option>
                <option value={`=rsql=${rsqlConfig.isShell}`}>Shells Only</option>
                <option value={`=rsql=${rsqlConfig.isNotShell}`}>No Shells</option>
            </Select>
            <FormButtons />
        </ServicesSearchForm>
    );
}

MoviesAndProgramsSearchForm.propTypes = {
    noScroll: PropTypes.bool,
    servicesDataKey: PropTypes.string.isRequired,
};

export default MoviesAndProgramsSearchForm;
